exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".notifications-form__email {\n  margin-bottom: 3rem; }\n  .notifications-form__email .o-checkbox {\n    margin-top: 1rem; }\n", "", {"version":3,"sources":["/tmp/build_3f9f81bc/src/containers/Accounts/Edit/src/containers/Accounts/Edit/NotificationsForm.scss"],"names":[],"mappings":"AACA;EACI,oBAAmB,EAKtB;EAND;IAIQ,iBAAgB,EACnB","file":"NotificationsForm.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.notifications-form__email {\n    margin-bottom: 3rem;\n\n    .o-checkbox {\n        margin-top: 1rem;\n    }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"variables/"; @import /"mixins/";","includePaths":["/tmp/build_3f9f81bc/src/scss"]}!./src/containers/Accounts/Edit/NotificationsForm.scss
// module id = 485
// module chunks = 0